import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { ListOrdered, MailCheck } from "lucide-react";

export function WaitlistPanel() {
  const { data } = useQuery({ queryKey: ["admin-waitlist"], queryFn: async () => (await api.get("/admin/waitlist")).data, refetchInterval: 30000 });
  if (!data) return <div className="h-40 rounded-2xl bg-white/5 animate-pulse" />;
  const max = Math.max(1, ...data.top_cities.map((c) => c.count));
  return (
    <div data-testid="waitlist-panel" className="space-y-5">
      <div className="glass rounded-2xl p-5">
        <h3 className="font-display font-bold flex items-center gap-2"><ListOrdered className="h-4 w-4 text-amber-300" /> Where to launch next <span data-testid="waitlist-total" className="ml-auto text-sm text-slate-400">{data.total} on the waitlist</span></h3>
        <p className="text-xs text-slate-400 mt-1">Switching on a Launch Area for a city automatically emails everyone waitlisted there.</p>
        <div className="mt-4 space-y-2.5">
          {data.top_cities.length === 0 && <p className="text-sm text-slate-400">No one on the waitlist yet.</p>}
          {data.top_cities.map((c) => (
            <div key={`${c.city}-${c.country}`} data-testid="waitlist-city-row" className="text-sm">
              <div className="flex items-center justify-between"><span className="font-semibold">{c.city}, {c.country}</span>
                <span className="text-xs text-slate-400">{c.count} waiting{c.notified ? ` · ${c.notified} emailed` : ""}</span></div>
              <div className="h-1.5 rounded-full bg-white/10 mt-1 overflow-hidden"><div className="h-full rounded-full bg-amber-400" style={{ width: `${(c.count / max) * 100}%` }} /></div>
            </div>
          ))}
        </div>
      </div>
      <div className="glass rounded-2xl p-5">
        <h3 className="font-display font-bold mb-3">Latest sign-ups</h3>
        {data.recent.map((w) => (
          <div key={w.id} data-testid="waitlist-recent-row" className="flex items-center gap-2 text-sm py-1.5 border-b border-white/5 last:border-0">
            <span className="flex-1 truncate">{w.name || w.email} <span className="text-slate-500">· {w.city}, {w.country}</span></span>
            {w.notified_at && <MailCheck className="h-4 w-4 text-emerald-400" title="Launch email sent" />}
            <span className="text-xs text-slate-500">{new Date(w.created_at).toLocaleDateString("en-GB")}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
